import React, { Component } from 'react'
import PageHeaderSection from '../components/sections/PageHeaderSection'
import TrainersSection from '../components/sections/TrainersSection'
import {Helmet} from "react-helmet";
export class TrainersPage extends Component {
  componentDidMount(){
    window.scrollTo(0, 0);
   
  }
  render() {
  
    return (
      <div className='trainer_main_cont'>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Peşəkar Müəllimlərimiz - Nicode Academy</title>
          <meta name="description" content="Nicode Academy-nin peşəkar müəllimləri ilə Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyaları öyrənin. Təcrübəli və sertifikatlı mütəxəssislərdən ibarət komandamızla müasir təlimlər və praktiki təcrübə qazanın."/>
          <meta property="og:type" content="website" /> 
          <meta name="robots" content="all, index" /> 
          <meta property="og:description" content="Nicode Academy-nin peşəkar müəllimləri ilə Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyaları öyrənin. Təcrübəli və sertifikatlı mütəxəssislərdən ibarət komandamızla müasir təlimlər və praktiki təcrübə qazanın."/>
          <meta name="keywords" content="peşəkar müəllimlər, Data Science müəllimləri, Python müəllimləri, SQL təlimçisi, Excel təlimçisi, Nicode Academy müəllimləri, data analitika müəllimləri, Power BI təlimçisi, təlim müəllimləri" />
          <link rel="canonical" href="https://nicode.az/"/>
          <meta property="og:locale" content="az_AZ"/>
          <meta property="og:type" content="Peşəkar Müəllimlərimiz - Nicode Academy"/>
          <meta property="og:title" content="Peşəkar Müəllimlərimiz - Nicode Academy"/>
          <meta property="og:url" content="https://nicode.az/trainers"/>
          <meta property="og:site_name" content="https://nicode.az/trainers"/>
          <meta property="og:image" content="https://nicode.az/static/media/nicode2.65d12d39210d7ec2788e.png"/>
          <meta property="og:image:secure_url" content="https://nicode.az/static/media/nicode2.65d12d39210d7ec2788e.png"/>

          <meta name="twitter:site" content="nicode.az"/>
          <meta property="og:url" content="http://nicode.az/trainers"/>
          <meta property="og:title" content="Peşəkar Müəllimlərimiz - Nicode Academy"/>
          <meta property="og:description" content="Nicode Academy-nin peşəkar müəllimləri ilə Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyaları öyrənin. Təcrübəli və sertifikatlı mütəxəssislərdən ibarət komandamızla müasir təlimlər və praktiki təcrübə qazanın."/>
        </Helmet>
        <PageHeaderSection title="Müəllimlərimiz" />
        <TrainersSection />
      </div>
    )
  }
}

export default TrainersPage
